// 価格パターン
export const PRICE_PATTERN_LIST = [
  { Code: '', Name: '&nbsp;',plain:'' },
  { Code: '0', Name: '&#9675;' ,plain:'○'},
  { Code: '1', Name: '&#9651;' ,plain:'△'},
  { Code: '2', Name: '&#9633;' ,plain:'□'},
  { Code: '3', Name: '&#9734;' ,plain:'☆'},
  { Code: '9', Name: '&minus;' ,plain:'−'},
] as const;

